<script setup lang="ts">
const props = defineProps<{
    direction: 'left' | 'right';
    isDisabled?: boolean;
}>();
</script>

<template>
	<!-- eslint-disable max-len -->
	<button
		class="arrow-button"
		:class="{
			'arrow-button--left': props.direction === 'left',
			'arrow-button--right': props.direction === 'right'
		}"
		:disabled="props.isDisabled"
	>
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
		>
			<g>
				<path
					d="M13.2002 12L9.3002 8.09995C9.11686 7.91662 9.0252 7.68328 9.0252 7.39995C9.0252 7.11662 9.11686 6.88328 9.3002 6.69995C9.48353 6.51662 9.71686 6.42495 10.0002 6.42495C10.2835 6.42495 10.5169 6.51662 10.7002 6.69995L15.3002 11.3C15.4002 11.4 15.471 11.5083 15.5127 11.625C15.5544 11.7416 15.5752 11.8666 15.5752 12C15.5752 12.1333 15.5544 12.2583 15.5127 12.375C15.471 12.4916 15.4002 12.6 15.3002 12.7L10.7002 17.3C10.5169 17.4833 10.2835 17.575 10.0002 17.575C9.71686 17.575 9.48353 17.4833 9.3002 17.3C9.11686 17.1166 9.0252 16.8833 9.0252 16.6C9.0252 16.3166 9.11686 16.0833 9.3002 15.9L13.2002 12Z"
					fill="currentColor"
				/>
			</g>
		</svg>
	</button>
</template>

<style lang="scss" scoped>
.arrow-button {
    background-color: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
	cursor: pointer;
    padding: 8px;

	&:disabled {
		opacity: 0.5;
        cursor: default;
	}

	&--left {
		transform: rotate(180deg);
	}
}
</style>
